import { makeAutoObservable } from "mobx";
import { RSet } from "../../collections";
import { Tristate } from "../../core";
export class PreorderSettingsAvailability {
    constructor(params) {
        this.scope = params.scope;
        this.preorderSettings = params.preorderSettings;
        makeAutoObservable(this);
    }
    get unavailabilityReasons() {
        return this.isAvailable.isDefinitelyTrue
            ? RSet.empty()
            : RSet.singleton("Preorder");
    }
    get reasons() {
        const { fulfillmentTime, now } = this.scope;
        const reasons = [];
        if (fulfillmentTime === null) {
            return ["DateNotSelected"];
        }
        this.preorderSettings.forEach((preorderSettings) => {
            const dateRange = preorderSettings.dateRange(now);
            const inRange = dateRange.includes(fulfillmentTime);
            if (!inRange) {
                reasons.push(`${fulfillmentTime.toString} not in date range: ${dateRange.toString()} `);
            }
        });
        return reasons;
    }
    get isAvailable() {
        const { fulfillmentTime, now } = this.scope;
        const preorderRanges = this.preorderSettings.map((preorderSettings) => preorderSettings.dateRange(now));
        const isInThePast = preorderRanges.every((dateRange) => {
            return dateRange.days.every((day) => day.isBefore(now));
        });
        if (isInThePast) {
            return Tristate.False;
        }
        // TODO: return False if intersection of the preorderSettings and restaurant ordering hours (with holidays) is empty
        if (fulfillmentTime === null) {
            // FIXME Tristate.Maybe should be there, but such change breaks multiple e2e tests
            return Tristate.True;
        }
        if (preorderRanges.some((dateRange) => dateRange.includes(fulfillmentTime))) {
            return Tristate.True;
        }
        return Tristate.False;
    }
    accept(availabilityVisitor) {
        availabilityVisitor.visitPreorder(this);
    }
}
